module.exports = __webpack_public_path__ + "static/media/fire5.75cb3d01.svg";